import { SubResourceOperation } from "./sub-resource-operation";
import { IOperation } from "../operation.interface";

export class FieldOperation extends SubResourceOperation implements IOperation {

    transactionType = "FieldOperation";
}




// WEBPACK FOOTER //
// ./src/core/services/sync-up/operations/field-operation.ts